import Smartphones from 'Projects/views/ProjectsView/containers/Smartphones'
import Tablets from 'Projects/views/ProjectsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ProjectsView = getCurrentDeviceView(Smartphones, Tablets)

export default ProjectsView
